import { forEach } from 'lodash';
import Muuri from 'muuri/dist/muuri';

/* eslint-disable no-unused-vars */
var grid = new Muuri('.grid', {
    showDuration: 500,
    hideDuration: 500,
    layoutDuration: 500,
});

let singleProduct = document.querySelectorAll('.single-product');
let itemBorder = document.querySelectorAll('.item-border');
let itemImage = document.querySelectorAll('.item-image');
let itemTitle = document.querySelectorAll('.item-title');
grid.on('layoutStart', () => {
  singleProduct.forEach( e => {
    e.classList.remove('opacity-0');
    e.classList.add('opacity-100');
  });
  itemBorder.forEach( e => {
    e.classList.remove('opacity-0');
    e.classList.add('opacity-100');
  });
  //itemTitle.forEach( e => {
  //  e.classList.remove('opacity-0');
  //  e.classList.add('opacity-100');
  //});
});

/* eslint-enable no-unused-vars */

window.pageProducts = () => {
  return {
    currentCatValue: '',
    activeSubCat: 'all',
    init() {
        // Initialize grid
        this.grid = grid;
        
        let state = {category: '',};

        let el = window.location.pathname;
        let initCatValueSlug = el.split('/');
        let filterInit = `.${initCatValueSlug[3]}`;
        
        let elm = document.getElementById('dataInit');
        let initCatValue = `${elm.dataset.init}`;

        // For Taxonomy pages
        let sel = document.getElementById('main-categories');
        let selVal = sel.options;

        if (initCatValue && !window.location.hash) {
          this.currentCatValue = initCatValue;
          for(let i = 0; i < selVal.length; i++){
            if (selVal[i].value === initCatValue)
            sel.value = selVal[i].value;
          }
          setTimeout(() => (grid.filter(filterInit)), 30);
        } else {
          this.currentCatValue = 'todos';
        setTimeout(() => (grid.filter('.todos'), 30));
        }

        if(initCatValue && window.location.hash) {
          this.currentCatValue = initCatValue;
          for(let i = 0; i < selVal.length; i++){
            if (selVal[i].value === initCatValue)
            sel.value = selVal[i].value;
          }
          let hash = window.location.hash;
          let subCatSmall = document.getElementById('sub-categories-small');
          
          this.activeSubCat = hash.replace('#', '');
          subCatSmall.value = this.activeSubCat;
          setTimeout(() => (grid.filter(`.${this.activeSubCat}`), 30));
          console.log(this.activeSubCat);
        }


        // Detect History API support
        let supportsHistoryAPI = !!(window.history && window.history.pushState);

        // Return early if API is not supported
        if (!supportsHistoryAPI) {
          return;
        }

        //Set initial categorry value as indicated by data-init
        state['category'] = initCatValue;
      
        // Store an inital popstate event.state and remove hash
        // (initial hash filtering is not implemented)
        window.history.replaceState(state, '', window.location.pathname);

        window.onpopstate = () => {
          // Small main categories  
          let catSel = document.getElementById('main-categories');
          let catSelVal = sel.options;
          
          if (history.state['category']){

            this.currentCatValue = history.state['category'];

            // Update small main categories  
            for(let i = 0; i < catSel.length; i++){
              if (catSelVal[i].value === this.currentCatValue)
              catSel.value = catSelVal[i].value;
            }
          } else {
            this.currentCatValue = 'todos';
          }
          
          let stateCat = this.currentCatValue.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

          let selector = '';
  
          if (stateCat === '') {
            selector = '.todos' 
          } else {
            selector += `.${stateCat}`;
          }
          grid.filter(selector);

          if (history.state['subcategory'] !== '' && history.state['subcategory'] !== 'all'){
            this.activeSubCat = history.state['subcategory'];
            grid.filter(`.${this.activeSubCat}`);

            let subCatSel = document.getElementById('sub-categories-small');
            let subCatSelVal = subCatSel.options;

            for(let i = 0; i < subCatSel.length; i++){
              if (subCatSelVal[i].value === this.activeSubCat) {
                subCatSel.value = subCatSelVal[i].value;
              } 
            }
          } else {
            this.activeSubCat = 'all';
            // Update small subcategories
            document.getElementById('sub-categories-small').selectedIndex = 0;
          }
        }
    },
    catValue(e) {
        
      let selectElement = e.target;

      let val = selectElement.value;

      this.currentCatValue = val;

      // Update sub-category value so it shows 'All' as active tab when clicking parent category
      this.activeSubCat = 'all';

      let valClass = val.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

      document.getElementById('sub-categories-small').selectedIndex = 0;

      grid = this.grid;

      let selector = '';

      selector += `.${valClass}`;
      
      grid.filter(selector || '.todos');

      history.state['category'] = valClass;
      console.log(history.state);
      history.state['subcategory'] = this.activeSubCat;
      let newState = history.state;
      console.log(newState);
      window.history.pushState(newState, '', `/productos/categoria/${valClass}`);
    },
    subCatValue(e) {
        
        let selectElement = e.target;

        // Get element sub-category
        let val = selectElement.value;

        // Construct slug from parent category value for posterior filtering
        let valClass = val.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  
        // Reference grid, otherwise filter function returns 'undefined'
        let grid = this.grid;
  
        let selector = '';

        // Construct class
        selector += `.${valClass}`;

        console.log(selector);
        
        // Filter by class
        grid.filter(selector);

        this.activeSubCat = valClass;

        history.state['category'] = this.currentCatValue;

        history.state['subcategory'] = this.activeSubCat;

        let catSlug = this.currentCatValue.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        let newState = history.state;

        window.history.pushState(newState, '', `/productos/categoria/${catSlug}#${valClass}`);
      },
      catValueLarge(e) {
        let selectElement = e.target;

        e.preventDefault();

        // Get element category
        let val = selectElement.dataset.value;
        
        // Update parent categroy value for correct display of sub-categories
        this.currentCatValue = val;

        // Update sub-category value so it shows 'All' as active tab when clicking parent category
        this.activeSubCat = 'all';
  
        // Construct slug from parent category value for posterior filtering
        let valClass = val.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        // Reference grid, otherwise filter function returns 'undefined'
        grid = this.grid;
  
        let selector = '';
        
        if (valClass === '') {
          selector = '.todos' 
        } else {
          selector += `.${valClass}`;
        }
        
        grid.filter(selector);

        // Update small main categories  
        let sel = document.getElementById('main-categories');
        let selVal = sel.options;

        for(let i = 0; i < sel.length; i++){
          if (selVal[i].value === this.currentCatValue)
          sel.value = selVal[i].value;
        }

        // Update small subcategories
        document.getElementById('sub-categories-small').selectedIndex = 0;

        // Update state
        let oldState = history.state;
        console.log(oldState);

        history.state['category'] = val;
        history.state['subcategory'] = this.activeSubCat;

        let newState = history.state;

        console.log(history.state);

        window.history.pushState(newState, '', `/productos/categoria/${valClass}`);  
      },
      subCatValueLarge(e) {
        let selectElement = e.target;

        e.preventDefault();
  
        let val = selectElement.dataset.value;
  
        let valClass = val.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  
        this.grid = grid;
  
        let selector = '';
  
        if (valClass === '') {
          this.activeSubCat = 'all';
          selector = `.${this.currentCatValue.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()}`; 
        } else {
          this.activeSubCat = valClass;
          selector += `.${valClass}`;
        }
        
        this.grid.filter(selector);

        // Update small main categories  
        let sel = document.getElementById('sub-categories-small');
        let selVal = sel.options;

        if (valClass === '') {
          sel.selectedIndex = 0;
        } else {
          for(let i = 0; i < sel.length; i++){
            if (selVal[i].value === this.activeSubCat) {
              sel.value = selVal[i].value;
            } 
          }
        }

        history.state['category'] = this.currentCatValue;

        history.state['subcategory'] = this.activeSubCat;

        let catSlug = this.currentCatValue.replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        let newState = history.state;

        window.history.pushState(newState, '', `/productos/categoria/${catSlug}#${valClass}`);
      },
  };
}

window.item = () => {
    return {
        catParse() {
            let elements = document.querySelectorAll('.todos');
            
            if (elements) {
            elements.forEach((element) => {
              if (element.dataset.rawCategories){

                let rawCats = element.dataset.rawCategories;
                let splitCats = rawCats.split('|');

                console.log(splitCats);
                
                
                let mainCat = splitCats[0].replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                let subCat = splitCats[1].replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

                console.log(subCat);
                element.classList.add(mainCat);

                if (subCat !==''){
                  element.classList.add(subCat);
                }
              }
                element.removeAttribute('data-raw-categories');
           });
          }
        }
      };
  }